import { render, staticRenderFns } from "./ContactoView.vue?vue&type=template&id=3cce348a&scoped=true"
import script from "./ContactoView.vue?vue&type=script&lang=js"
export * from "./ContactoView.vue?vue&type=script&lang=js"
import style0 from "./ContactoView.vue?vue&type=style&index=0&id=3cce348a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce348a",
  null
  
)

export default component.exports